import variables from '../variables';

const MuiFormHelperText = {
  styleOverrides: {
    root: {
      ...variables.typography.body2,
      margin: 0,
      color: variables.text.primary,
    },
  },
};

export default MuiFormHelperText;
